<template>
  <main-layout>
    <div>
      <edit-dialog
        :tag="tagToUpdate"
        @close="closeEditDialog"
        @updated="tagUpdated"
        v-if="isEditDialogOpened"
      />
      <create-dialog
        :clientId="clientId"
        :makerId="makerId"
        @close="isNewTagOpened = false"
        @created="tagCreated"
        v-if="isNewTagOpened"
      />
      <v-row no-gutters align="center" class="content-header">
        <span class="font-weight-bold">Tags</span>
        <v-spacer></v-spacer>
        <v-btn :disabled="!$canWrite" dark color="primary" elevation="0" @click="$canWrite && (isNewTagOpened = true)">
          <v-icon left>add</v-icon>
          Nouveau tag
        </v-btn>
      </v-row>
      <v-col class="py-2 search-bar border-component">
        <v-text-field
          v-model="searchString"
          placeholder="Rechercher un tag..."
          prepend-icon="search"
          hide-details
          dense
          clearable
          class="input-no-b-line"
        ></v-text-field>
      </v-col>
      <n-card class="mt-4">
        <div class="pa-12" v-if="isLoading">
          <v-progress-linear
            color="primary"
            indeterminate
            rounded
            height="6"
          />
        </div>
        <div class="pa-12" v-else-if="!filteredTags.length">
          <v-icon>local_offer</v-icon>
          <h3 class="d-block py-3">Aucun tag</h3>
          <v-btn :disabled="!$canWrite" text small outlined color="primary darken-2" @click="$canWrite && (isNewTagOpened = true)">
            <v-icon>add</v-icon>
            Créer le premier
          </v-btn>
        </div>
        <v-list class="pa-0 border-component">
          <template v-for="(tag, i) in filteredTags">
            <v-list-item :key="tag.id">
              <v-list-item-avatar size="20" style="margin-top: 4px;">
                <v-avatar :color="tag.color"></v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                {{ tag.label }}
              </v-list-item-content>
              <v-list-item-action>
                <v-btn :disabled="!$canWrite" icon small @click="$canWrite && (openEditDialog(tag))">
                  <v-icon small>edit</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="`divider-${tag.id}`" v-if="filteredTags.length > 1 && i < (filteredTags.length - 1)" />
          </template>
        </v-list>
      </n-card>
    </div>
  </main-layout>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import MainLayout from '@/views/settings/MainLayout.vue';
import EditDialog from '@/components/Tags/Dialog.vue';
import CreateDialog from '@/components/Tags/CreateDialog.vue';

export default {
  name: `SettingsTags`,
  data: () => ({
    isLoading: false,
    searchString: ``,
    isNewTagOpened: false,
    isEditDialogOpened: false,
    tagToUpdate: null,
  }),
  computed: {
    ...mapState(`ui/settingsTags`, [
      `tags`,
    ]),
    ...mapState(`model/client`, [
      `company`,
      `isAggregator`,
      `isMaker`,
    ]),
    clientId() {
      return this.isAggregator ? this.company.id : null;
    },
    makerId() {
      return !this.isAggregator ? this.company.id : null;
    },
    flavoredTags() {
      return _.chain(this.tags)
        .map(tag => ({
          ...tag,
          $searchString: _.toLower(tag.label),
        }))
        .sortBy(`$searchString`)
        .value();
    },
    filteredTags() {
      let tags = this.flavoredTags;
      if (this.searchString) {
        const searchString = _.lowerCase(this.searchString);
        tags = _.filter(tags, tag =>
          tag.$searchString.indexOf(searchString) !== -1
        );
      }
      return tags;
    },
  },
  methods: {
    tagCreated(tag) {
      this.isNewTagOpened = false;
      this.$store.commit(`ui/settingsTags/ADD_TAG_TO_LIST`, tag);
    },
    openEditDialog(tag) {
      this.tagToUpdate = tag;
      this.isEditDialogOpened = true;
    },
    closeEditDialog() {
      this.isEditDialogOpened = false;
      this.tagToUpdate = null;
    },
    tagUpdated(tag) {
      this.$store.commit(`ui/settingsTags/UPDATE_TAG`, tag);
      this.tagToUpdate = null;
      this.isEditDialogOpened = false;
    },
  },
  async beforeMount() {
    this.isLoading = true;
    this.tagToUpdate = null;
    if (this.isMaker) {
      await this.$store.dispatch(`ui/settingsTags/fetchMakerTags`, this.clientId);
    } else {
      await this.$store.dispatch(`ui/settingsTags/fetchClientTags`, this.makerId);
    }
    this.isLoading = false;
  },
  components: {
    MainLayout,
    EditDialog,
    CreateDialog,
  },
};
</script>

<style lang="scss">
</style>
